import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["tr", "en"],
  defaultLocale: "tr",
  // Tarayıcı diline göre yönlendirme (Accept-Language)
  localeDetection: true,
  localePrefix: "always",
});

export type Locale = (typeof routing.locales)[number];
